import React from "react";
import { Navigate } from "react-router-dom";

import { CLIENT_HOME_PATH } from "@/constants/navigation";
import { useClientPlatformAccess } from "@/hooks/useClientPlatformAccess";

/**
 * The Distributor section's routes (Programs Dashboard, Programs, Program
 * Policies, Users) follow the nav: without the Distributions access level a
 * direct URL lands on the console home instead. OnboardingGate has already
 * settled context discovery before a shell route renders.
 */
export function DistributorRoute({
    children
}: {
    children: React.ReactNode;
}): React.ReactElement {
    const { distributionsAccess } = useClientPlatformAccess();
    if (!distributionsAccess) return <Navigate to={CLIENT_HOME_PATH} replace />;
    return <>{children}</>;
}

/** A route component wrapped in `DistributorRoute`. */
export function distributorOnly(
    Page: React.ComponentType
): React.ComponentType {
    function DistributorOnlyPage(): React.ReactElement {
        return (
            <DistributorRoute>
                <Page />
            </DistributorRoute>
        );
    }
    DistributorOnlyPage.displayName = `DistributorOnly(${Page.displayName ?? Page.name})`;
    return DistributorOnlyPage;
}
